import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../app.component";
import {ActivatedRoute} from "@angular/router";
import {EMPTY, of} from 'rxjs';
import {catchError, map, switchMap, take} from 'rxjs/operators';
import {User} from "../Models/User";
import {ROUTES_PATHS} from "../const/routes";
import {SiteKeyEnum} from "../enums/site-key.enum";

@Component({
	selector: 'app-sign-on',
	templateUrl: './sign-on.component.html',
	styleUrls: ['./sign-on.component.less'],
	encapsulation: ViewEncapsulation.None
})
export class SignOnComponent implements OnInit {

	constructor(
		public app: AppComponent,
		private route: ActivatedRoute
	) {
	}

	ngOnInit(): void {
		this.route.queryParamMap.pipe(
			take(1),
			map(params => {
				const cadastreToken = params.get('cadastre_token');
				const otherToken = params.get('other_token');

				if (cadastreToken) return {referer: SiteKeyEnum.CADASTRE, token: cadastreToken};
				if (otherToken) return {referer: 'other', token: otherToken};

				return null;
			}),
			switchMap(data => {
				if (!data) {
					console.log("No valid token found!");
					return EMPTY;
				}

				console.log("Token found:", data);

				return this.app.apiToolsService.tokenValidation(data.referer, data.token).pipe(
					map(res => ({...res, referer: data.referer})), // on garde le referer
					catchError(err => {
						console.error("[ERR] tokenValidation KO !", err);
						return EMPTY;
					})
				);
			}),
			switchMap(res => {
				if (!res?.sub) return EMPTY;

				return this.app.apiToolsService.subValidation(res.referer, res.sub).pipe(
					catchError(err => {
						console.error("[ERR] subValidation KO !", err);
						return EMPTY;
					})
				);
			})
		)
			.subscribe({
				next: res => {
					console.log("Final result:", res);

					let userDto: User = new User();
					userDto.USR_NOM = res?.lastname;
					userDto.USR_PRENOM = res?.fistname;
					userDto.USR_EMAIL = res?.email;
					userDto.USR_TEL_MOBILE = "";
					userDto.USR_NUM_AGREEMENT = res?.sub;
					userDto.USR_NUMERO_EXTERNE = "3DA2B2B1-9E37-41A8-AFE1-85F8FE70AA93";
					userDto.ACTE_ID = 99;

					this.app.apiToolsService.inscription(userDto).subscribe(
						(res: any) => {
							console.log("res inscription ==> ", res);
							localStorage.setItem("token", JSON.stringify(res));

							this.app.router.navigate([ROUTES_PATHS.WELCOME]);
						},
						(error: any) => {
							console.error(error.error);
						});
				}
			});
	}
}
